<template>
<div>
    <div class=" important pa-2">
        {{ $t('distribuiton.booking.room_types') }}
    </div>
    <v-card v-for="room in room_types" :key="'room_'+room.id" class="pa-2 mx-md-2 my-2">
        <v-row align="center" no-gutters>
            <v-col sm="6" cols="12" class="py-0 regular">
                <span v-if="room.name">
                    {{ room.name }}
                </span>
                <span v-else>
                    {{ $t('room_type_slug.' + room.slug) }}
                </span>
                <span class="detail">({{ room.id }})</span>
            </v-col>
            <v-col sm="6" cols="12" class="py-0">
                <v-select :items="computedItems" v-model="room.partner.id" :menu-props="{'content-class':'room-selection'}" item-text="name" item-value="id" label="Partner room" clearable @change="setRoomName(room),isDirty()">
                    <template v-slot:selection="data">
                        <div class="text-truncate regular" style="max-width: 250px">
                            {{data.item.name}}
                        </div>
                    </template>
                    <template v-slot:item="data">
                        <div>
                            <span>{{ data.item.name }}</span>
                            <span class="detail">({{ data.item.id }})</span>
                        </div>
                    </template>
                </v-select>
            </v-col>
        </v-row>
    </v-card>

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    name: `channel-manager-tab`,

    props: {
        system_id: [Number, String],
        partner_id: [Number, String],
        integration_id: [Number, String],
    },
    components: {},

    data() {
        return {
            maps_rooms: [],
            rooms_mapped_ids: [],
            room_types: [],
            rooms_selected: [],
            room_types_booking: [],

            id_map_delete: null,
            index_map_delete: null,
        }
    },

    watch: {},

    computed: {
        computedItems() {
            return this.room_types_booking.map(item => {
                return {
                    name: item.name,
                    id: item.id,
                    disabled: this.computedIds.includes(item.id)
                }
            })
        },
        computedIds() {
            return this.room_types.map(item => {
                if(item.partner.id) {
                    return item.partner.id
                }

            })
        },
    },

    created() {
        this.getRoomMapping();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getRoomMapping() {
            this.getRoomTypes()
                .then(() => this.getMappingsRooms())
                .then(() => this.getRoomTypesBooking())
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {});
        },

        getRoomTypes() {
            if(!this.system_id) {
                return;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/room-types";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.system_id
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (room) {
                        room.partner = {
                            id: null,
                            name: null
                        }
                        this.room_types.push(room);
                    }.bind(this))
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getMappingsRooms() {

            if(!this.integration_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/room-type-mappings";

            let params = {
                params: {
                    integration_id: this.integration_id,
                }
            };
            this.$axios.get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(function (room_maped) {
                        this.room_types.forEach(function (room) {
                            if(room.id == room_maped.system_id) {
                                room.partner.id = room_maped.partner_id.toString();
                                room.partner.name = room_maped.partner_name;
                                this.rooms_selected.push(room_maped.partner_id.toString())
                            }
                        }.bind(this))
                    }.bind(this))
                    this.maps_rooms = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});

        },

        getRoomTypesBooking() {
            if(!this.partner_id) {
                return;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/booking/room-types";

            // setup query params
            let params = {
                params: {
                    partner_hotel_id: this.partner_id,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    this.room_types_booking = response.data;
                    return new Promise(function (resolve, reject) {
                        resolve(response.data);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        setRoomName(room) {
            if(room.partner.id) {
                room.partner.name = this.room_types_booking.filter(item => item.id == room.partner.id)[0].name;
            }
        },

        async saveItem() {
            let ids_maps_delete = [];
            let new_maps = [];
            this.room_types.forEach(function (room, index) {
                let old_map = false;
                this.maps_rooms.forEach(function (map) {
                    if(map.system_id == room.id) {
                        old_map = true;
                        if(map.partner_id != room.partner.id) {
                            ids_maps_delete.push(map.id);
                            if(room.partner.id) {
                                new_maps.push(room);
                            }
                        }
                    }
                })
                if(!old_map && room.partner.id) {
                    new_maps.push(room);
                }
            }.bind(this))

            await Promise.all(ids_maps_delete.map(async (id) => {
                await this.deleteMap(id);
            }))

            await Promise.all(new_maps.map(async (new_map) => {
                let item = {
                    integration_id: this.integration_id,
                    partner_room_type: {
                        id: new_map.partner.id,
                        name: new_map.partner.name,
                    },
                    system_room_type: {
                        id: new_map.id,
                        name: new_map.name,
                    },
                }
                await this.createMap(item);
            }))
        },

        async createMap(item) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/room-type-mappings";

            return this.$axios.post(endpoint, item)
                .then(response => {
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        async deleteMap(id) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/cm/room-type-mappings/";
            return this.$axios.delete(endpoint + id)
                .then(response => {
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        isDirty() {
            this.$parent.$emit("isDirty");
        },
    },
}
</script>
<style lang="stylus">
.room-selection
    .v-list__tile--active
        background-color: WhiteSmoke
</style>
